<script lang="ts">
  import {
    clickOutside,
    escape,
    place,
    portal,
    returnFocus,
    type PlaceAlignModes,
  } from "@lernetz/svelte-common/actions";
  import { AlignOrigin } from "@lernetz/svelte-common/actions/place";
  import { setContext } from "svelte";
  import { DropdownContext, createDropdownMenu, type Menu } from "./dropdown-menu";
  import { createOverlay, type Overlay } from "./overlay";

  export let align: PlaceAlignModes = "Top";
  export let group: string = undefined;
  export let isOpen = false;

  export let threshold: number = 10;

  export const overlay = createOverlay("menu", group);
  const menu = createDropdownMenu(overlay);

  $: {
    $overlay.opened = isOpen;
  }

  setContext<{ menu: Menu; overlay: Overlay }>(DropdownContext, {
    menu,
    overlay,
  });
</script>

<slot {overlay} {menu} open={$overlay.opened} />
{#if $overlay.opened}
  <div
    class="absolute z-dropdown"
    use:menu.root
    use:portal
    use:escape={overlay.close}
    use:place={{ align, reference: overlay.triggerReference(), threshold }}
    use:returnFocus
    use:clickOutside={{ handler: overlay.close, include: [overlay.triggerReference()] }}
  >
    <slot name="content" {overlay} {menu} scaleOrigin={AlignOrigin[align]} />
  </div>
{/if}
